import React from 'react';
import { Modal, Typography, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

/**
 * Modal component to show success message after catalog order update
 * 
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onClose - Function called when modal is closed
 * @param {number} props.productsCount - Number of products added
 * @param {number} props.orderableCount - Number of orderable products available
 * @param {Function} props.onOrderAssets - Function called when Order Assets button is clicked
 */
const SuccessProcessingModal = ({ visible, onClose, productsCount, orderableCount = 0, onOrderAssets }) => {
    return (
        <Modal
            title={null}
            open={visible}
            onCancel={onClose}
            footer={null}
            centered
            width={500}
            closable={false}
        >
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <CheckCircleOutlined
                    style={{
                        fontSize: '64px',
                        color: '#52c41a',
                        marginBottom: '24px'
                    }}
                />

                <Title level={3} style={{ marginBottom: '16px' }}>
                    Products Added Successfully!
                </Title>

                <Paragraph style={{ fontSize: '16px', marginBottom: '24px' }}>
                    <Text strong>
                        {productsCount} products have been added to the catalogue and are being processed.
                    </Text>
                </Paragraph>

                <Paragraph style={{ fontSize: '14px', color: '#666', marginBottom: orderableCount > 0 ? '24px' : '32px' }}>
                    You will receive a notification when the processing is completed.
                    <br />
                    Please return later to see the updated list in the catalogue.
                </Paragraph>

                {orderableCount > 0 && (
                    <div style={{
                        backgroundColor: '#f6ffed',
                        border: '1px solid #b7eb8f',
                        borderRadius: '6px',
                        padding: '16px',
                        marginBottom: '24px',
                        textAlign: 'left'
                    }}>
                        <Paragraph style={{ fontSize: '14px', marginBottom: '12px', color: '#52c41a' }}>
                            <strong>There are {orderableCount} products available to order.</strong>
                        </Paragraph>
                        <Paragraph style={{ fontSize: '13px', color: '#666', marginBottom: '0' }}>
                            Would you like to proceed with placing the order now? If you don't do it now, you'll need to go to the orders section and restart the order creation process.
                        </Paragraph>
                    </div>
                )}

                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    {orderableCount > 0 && (
                        <Button
                            type="primary"
                            size="large"
                            onClick={onOrderAssets}
                            style={{ minWidth: '140px' }}
                        >
                            Order Products
                        </Button>
                    )}
                    <Button
                        type={orderableCount > 0 ? "default" : "primary"}
                        size="large"
                        onClick={onClose}
                        style={{ minWidth: '120px' }}
                    >
                        Close
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default SuccessProcessingModal; 